import { motion } from "framer-motion";
import { LogoMark } from "@/components/Logo";

const letters = "BOO SCRIBBLES".split("");

export default function Preloader() {
  return (
    <motion.div
      data-testid="preloader"
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-ink"
      exit={{ y: "-100%" }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
    >
      <motion.div
        initial={{ scale: 0, rotate: -20 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ type: "spring", stiffness: 200, damping: 12 }}
      >
        <LogoMark size={72} />
      </motion.div>
      <div className="mt-6 flex overflow-hidden">
        {letters.map((l, i) => (
          <motion.span
            key={i}
            initial={{ y: "110%", opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.25 + i * 0.055, duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
            className={`font-display text-5xl sm:text-7xl ${i < 3 ? "text-pumpkin text-glow-orange" : "text-paper"}`}
          >
            {l === " " ? "\u00A0" : l}
          </motion.span>
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1.1 }}
        className="font-hand text-xl text-slime text-glow-slime"
      >
        coloring world is waking up...
      </motion.p>
    </motion.div>
  );
}
